/* @flow */
import * as Immutable from 'immutable';

type Params = {
    message: ?string,
    isAcknowledged: boolean,
    isAutoAcknowledge: boolean,
    autoAcknowledgeTimeout: ?number
};

export const Record: Class<Immutable.Record<Params>> = Immutable.Record({
    message: null,
    isAcknowledged: false,
    isAutoAcknowledge: false,
    autoAcknowledgeTimeout: null
});

export default class ErrorRecord extends Record {
    // eslint-disable-next-line no-useless-constructor
    constructor(params: $Shape<Params>) {
        super(params);
    }
}
